module.exports = __webpack_public_path__ + "img/pepay-ibon.49aa91e.png";